module.exports = __webpack_public_path__ + "static/media/LOGO_PATHE.0a28320a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/LOGO_PATHE.png
// module id = 9
// module chunks = 0